import React from 'react';

interface SamsaraLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export const SamsaraLogo: React.FC<SamsaraLogoProps> = ({
  width = 18,
  height = 18,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Samsara logo - stylized S shape */}
      <rect width="32" height="32" rx="6" fill="#1C1C1C" />
      <path
        d="M22.5 10.5C22.5 10.5 20.5 8 16 8C11.5 8 8 11 8 14.5C8 18 11 19.5 14 20.5C17 21.5 18.5 22.5 18.5 24C18.5 25.5 17 26.5 15 26.5C12 26.5 10 24.5 10 24.5"
        stroke="#00D26A"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 21.5C9.5 21.5 11.5 24 16 24C20.5 24 24 21 24 17.5C24 14 21 12.5 18 11.5C15 10.5 13.5 9.5 13.5 8C13.5 6.5 15 5.5 17 5.5C20 5.5 22 7.5 22 7.5"
        stroke="#00D26A"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SamsaraLogo;
